/**
 * Convenience function for getting indicator ids.
 * @param  {array} arr array to split
 * @return {array}     array of ids
 */
export default function getIndicatorIds(arr) {
  return arr.map((indicator) => indicator.split('|')[0]);
}



// WEBPACK FOOTER //
// ./app/utils/array/getIndicatorIds.js